import React from "react";
import Badge from "react-bootstrap/Badge";

export const activeStatus = [
  "active",
  "inactive",
  "expiring",
  "expired",
  "awaiting",
  "terminated",
];

const PolicyItemStatus = (props) => {
  const { status = "" } = props;
  let statusBadge = "info";

  switch (status) {
    case "active":
      statusBadge = "success";
      break;
    case "expiring":
      statusBadge = "warning";
      break;
    case "expired":
      statusBadge = "danger";
      break;
    default:
      statusBadge = "default";
      break;
  }
  let widget = <Badge className={`bg-${statusBadge}`}>{status}</Badge>;

  return widget;
};

export default PolicyItemStatus;
